import {Component} from "./Component";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {AjaxNavigation} from "./AjaxNavigation";
import {EventsPage} from "../Pages/EventsPage";
import {createLogger} from "../util/logger";

const console = createLogger("ScrollAnimations");

export class ScrollAnimations extends Component {
    static name = "scroll-animations";

    get name() {
        return ScrollAnimations.name;
    }

    static TRIGGER_UPDATE = "scroll-animations:trigger-update";

    constructor(el) {
        super(el);

        this.onLoadEnd = this.onLoadEnd.bind(this);

        this.addEventListener(document.body, AjaxNavigation.EVENT_LOAD_END, this.onLoadEndAjaxNavigation.bind(this));
        this.addEventListener(document.body, EventsPage.EVENT_PAGE_LOADED, this.onLoadEnd.bind(this));

        this.addEventListener(document.body, ScrollAnimations.TRIGGER_UPDATE, this.onTriggerUpdate.bind(this));


        requestAnimationFrame(() => this.setupAnimations());
    }

    /**
     *
     * @param {HTMLElement} el
     */
    static updateAnimations(el) {
        console.log("updateAnimations", el);
        el.dispatchEvent(new CustomEvent(ScrollAnimations.TRIGGER_UPDATE, {
            bubbles: true,
            cancelable: false,
        }));
    }

    /**
     *
     * @param {CustomEvent} e
     */
    onTriggerUpdate(e) {
        console.log("onTriggerUpdate");
        this.setupAnimations(e.target);
    }

    onLoadEnd(e) {
        console.log("onLoadEnd", e.detail);

        this.setupAnimations();
    }

    /**
     *
     * @param {CustomEvent} e
     */
    onLoadEndAjaxNavigation(e) {
        console.log("onLoadEndAjaxNavigation", e.detail);
        const {target} = e.detail;

        if (!target) return;

        this.setupAnimations(target);
    }

    /**
     * Setup animations
     * @param el Optional root element
     */
    setupAnimations(el) {

        const root = el || this.el;

        ScrollTrigger.update();

        const scrollTriggerDefaults = {
            start: "top bottom",
            toggleActions: "play complete none none",
        }

        //Title animations
        const titles = Array.from(root.querySelectorAll(".section__title"));
        titles.forEach((title, i) => {
            title.classList.add("scroll-title");
            title.innerHTML = `<span>${title.innerHTML}</span>`;

            gsap.to(title.firstElementChild, {
                y: 0,
                duration: .5,
                scrollTrigger: {
                    ...scrollTriggerDefaults,
                    trigger: title.firstElementChild,
                },
            });
        });

        // Show animations
        const show = Array.from(root.querySelectorAll(".scroll-show"));
        show.forEach((el) => {
            gsap.to(el, {
                duration: .5,
                opacity: 1,
                y: 0,
                scrollTrigger: {
                    ...scrollTriggerDefaults,
                    trigger: el,
                }
            });
        });

        // Stagger animations
        const stagger = Array.from(root.querySelectorAll(".scroll-stagger"));
        stagger.forEach((el) => {
            gsap.to(el.children, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                stagger: 0.2,
                scrollTrigger: {
                    ...scrollTriggerDefaults,
                    trigger: el,
                },
            });
        });

        window.scrollTo({
            top: window.scrollY + 1,
        });

        ScrollTrigger.update();
    }


}
